import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';
import b from 'b_';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import Dropdown from '../Dropdown';
import './TopBarDropdown.css';
import './OldTopBarDropdown.css';

const newBlock = b.lock('NewTopBarDropdown');
const oldBlock = b.lock('TopBarDropdown');

export default class TopBarDropdown extends Component {
    static propTypes = {
        className: PropTypes.string,
        type: PropTypes.string,
        onClose: PropTypes.func,
    };

    static defaultProps = {
        type: 'default',
        onClose: () => {},
    };

    render() {
        const { children, className, type, onClose, ...otherProps } = this.props;
        const block = isFuse5Enabled() ? newBlock : oldBlock;
        return <Dropdown
            className={cn(block({ type }), className)}
            onClose={onClose}
            {...otherProps}
        >
            {children}
        </Dropdown>;
    }
}
